import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { useController } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Divider from '@material-ui/core/Divider';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import styles from './styles';
import CloseIcon from 'assets/images/close-icon.svg';
import cn from 'classnames';

const EmailNotifications = ({ classes, pageType, control, errors }) => {
  const { emailReceivers } = useSelector((state) => state.settings.settings);

  const {
    field: { onChange, value: EmailNotifications },
  } = useController({
    name: 'emailReceivers',
    control,
    defaultValue: [],
  });

  const [isShowEmails, setShowEmails] = useState(false);

  useEffect(() => {
    onChange(emailReceivers || []);
  }, [emailReceivers]);

  const handleNotificationChange = (i, fieldName) => (e) => {
    const { value } = e.target;
    const nextValue = EmailNotifications.map((notificationObject, index) =>
      index === i ? { ...notificationObject, [fieldName]: value } : notificationObject
    );
    onChange(nextValue);
  };
  const handleEmailRemoving = (i) => () => {
    const nextValue = EmailNotifications.filter((_, index) => index !== i);
    onChange(nextValue);
  };
  const handleAddEmail = () => {
    setShowEmails(true);
    onChange([...EmailNotifications.filter((v) => v.email), { name: '', email: '' }]);
  };

  return (
    <div className={classes.root}>
      <Typography variant="h4">Email Notifications</Typography>
      <div className={classes.actionsWrapper}>
        {pageType === 'edit' && (
          <Button
            variant="text"
            className={classes.primaryTextButton}
            onClick={handleAddEmail}
            disableRipple
          >
            + Add Email
          </Button>
        )}
        {isShowEmails && (
          <div className={classes.emailsWrapper}>
            {EmailNotifications.map((notificationObject, index) => (
              <Grid container spacing={5} key={`emailReceivers-${index}`} alignItems="center">
                <Grid item xs={10} sm={6} md={3} className={classes.zeroPaddingTop}>
                  {index === 0 && (
                    <Typography
                      variant="body1"
                      color="textSecondary"
                      className={classes.regularFontWeight}
                    >
                      Name:
                    </Typography>
                  )}
                  <TextField
                    id={`emailReceivers[${index}].name`}
                    name={`emailReceivers[${index}].name`}
                    type="text"
                    value={notificationObject.name}
                    className={classes.textField}
                    onChange={handleNotificationChange(index, 'name')}
                    variant="outlined"
                    inputProps={{ 'aria-label': 'Name Notifications' }}
                    fullWidth
                    disabled={pageType === 'read'}
                  />
                </Grid>
                <Grid item xs={10} sm={6} md={3} className={classes.zeroPaddingTop}>
                  {index === 0 && (
                    <Typography
                      variant="body1"
                      color="textSecondary"
                      className={classes.regularFontWeight}
                    >
                      Email:
                    </Typography>
                  )}
                  <TextField
                    id={`emailReceivers[${index}].email`}
                    name={`emailReceivers[${index}].email`}
                    type="email"
                    value={notificationObject.email}
                    className={classes.textField}
                    onChange={handleNotificationChange(index, 'email')}
                    variant="outlined"
                    inputProps={{ 'aria-label': 'Email Notifications' }}
                    fullWidth
                    disabled={pageType === 'read'}
                  />
                </Grid>
                {pageType === 'edit' && (
                  <span
                    className={classes.removeEmail}
                    onClick={handleEmailRemoving(index)}
                    style={index === 0 ? { marginTop: 15 } : {}}
                  >
                    <img src={CloseIcon} alt="delete" />
                  </span>
                )}
                <Grid item xs={12} className={classes.mobileDivider}>
                  <Divider style={{ margin: '1px 0 15px'}}/>
                </Grid>
              </Grid>
            ))}
          </div>
        )}
        {!!EmailNotifications.length && (
          <div
            className={classes.buttonWrapper}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowEmails((prev) => !prev);
            }}
          >
            <div className={classes.nonActionsIcon}>
              <ExpandMoreIcon className={cn(isShowEmails ? '' : classes.reversIcon)} />
            </div>
            <p className={classes.textIconMore}>{`${
              isShowEmails ? 'Hide' : 'Show'
            } email addresses`}</p>
          </div>
        )}
      </div>
    </div>
  );
};

EmailNotifications.propTypes = {
  classes: propTypes.object.isRequired,
  pageType: propTypes.string.isRequired,
  errors: propTypes.object.isRequired,
  control: propTypes.object.isRequired,
};

export default withStyles(styles)(EmailNotifications);
